// extracted by mini-css-extract-plugin
export var isPrintedCell = "_y0-1";
export var printerIcon = "_y0-0";